import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { AudienceSection } from './components/AudienceSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { ImagineSection } from './components/ImagineSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    ;
    (function (f: any, b: any, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e);
      t.async = true;
      t.src = v;
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq('init', '1343885107577709');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-gold/30 selection:text-navy" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <ProblemSection data-id="element-3" />
        <SolutionSection data-id="element-4" />
        <AudienceSection data-id="element-5" />
        <DifferentiatorSection data-id="element-6" />
        <ImagineSection data-id="element-7" />
        <CTASection data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}